var rmUtil = require("../rmlibrary_old/util");
var PDFNode = require("./node");

function PDFTextNode() {
    PDFNode.apply(this, arguments);
}
rmUtil.inherits(PDFTextNode, PDFNode);

PDFTextNode.prototype.setChildren = function (children) {
    clearStartWhitespace(children);
    clearEndWhitespace(children);
    clearExtraWhiteSpace(children);
    this.children = removeEmptyNodes(children);
};

function clearExtraWhiteSpace(children) {
    var lastEndedWhite = false;

    function _clearExtraWhiteSpace(children) {
        children.forEach(function (child) {
            if (typeof child.content === "string") {
                child.content = child.content.replace(/\s+/g, " ");
                if (lastEndedWhite) child.content = child.content.replace(/^\s+/, "");
                lastEndedWhite = /\s+$/.test(child.content);
            } else if (!child.styles.display || child.styles.display === "inline") {
                _clearExtraWhiteSpace(child.children);
            } else {
                lastEndedWhite = false;
            }
        });
    }
    _clearExtraWhiteSpace(children);
}

function clearStartWhitespace(children) {
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.isInlineBlock && child.isInlineBlock()) return true;
        else if (typeof child.content === "string") {
            child.content = child.content.replace(/^\s+/, "");
            if (child.content.length > 0) return true;
        } else if (Array.isArray(child.children)) {
            if (clearStartWhitespace(child.children)) return true;
        }
    }
    return false;
}
function clearEndWhitespace(children) {
    for (var i = children.length - 1; i >= 0; i--) {
        var child = children[i];
        if (child.isInlineBlock && child.isInlineBlock()) return true;
        else if (typeof child.content === "string") {
            child.content = child.content.replace(/\s+$/, "");
            if (child.content.length > 0) return true;
        } else if (Array.isArray(child.children)) {
            if (clearEndWhitespace(child.children)) return true;
        }
    }
    return false;
}
function removeEmptyNodes(children) {
    var ret = [];
    children.forEach(function (child) {
        if (child.isInlineBlock && child.isInlineBlock()) ret.push(child);
        else if (typeof child.content === "string" && child.content.length > 0) ret.push(child);
        else if (Array.isArray(child.children)) {
            child.children = removeEmptyNodes(child.children);
            if (child.children.length > 0) ret.push(child);
        }
    });
    return ret;
}

// function flattenNodes(parent, children) {
//     children.forEach(function (node) {
//         if (!node.tagName) {
//             node.styles = parent.styles;
//             flattened.push(node);
//             return flattened;
//         }
//         var display = base.getDisplay(node, styleManager);
//         if (display === 'inline-block' || node.tagName.toLowerCase() === 'img') {
//             flattened.push(node);
//             return flattened;
//         }
//         if (display !== 'inline') {
//             util.warn("Display type '" + display + "' not supported in inline element.");
//             return flattened;
//         } else {
//             var childNodes = Array.prototype.slice.call(node.childNodes, 0);
//             return flattened.concat(flattenNodes(childNodes, styleManager));
//         }
//     });
// }
//
// PDFTextNode.prototype._flattenNodes = function (children) {
//     var flattened = [];
//
//
// };

function hasContent(children) {
    if (!Array.isArray(children)) return false;
    for (var i = 0; i < children.length; i++) {
        if (!children[i].tagName && !/^\s*$/.test(children[i].content)) return true;
        if (
            children[i].styles.display !== "inline" ||
            children[i].tagName === "img" ||
            hasContent(children[i].children)
        )
            return true;
    }
    return false;
}

PDFTextNode.prototype.hasContent = function () {
    return hasContent(this.children);
};

function flattenNodes(nodes) {
    var flattened = [];
    function _flatten(node) {
        if (node.content) flattened.push(node);
        else if (node.isInlineBlock && node.isInlineBlock()) flattened.push(node);
        else if (Array.isArray(node.children))
            node.children.forEach(function (child) {
                _flatten(child);
            });
    }
    nodes.forEach(_flatten);
    return flattened;
}

PDFTextNode.prototype._getOptions = function () {
    return {
        size: this.computedStyles.size,
        lineHeight: this.computedStyles.lineHeight,
        font: this.computedStyles.font,
        italic: this.computedStyles.italic,
        bold: this.computedStyles.bold,
        color: this.computedStyles.color,
        align: this.computedStyles.align,
        letterSpacing: this.computedStyles.letterSpacing,
        transform: this.computedStyles.transform,
        underline: this.computedStyles.underline,
        text: this.content,
        overflowWrap: this.computedStyles.overflowWrap,
        wordWrap: this.computedStyles.wordWrap,
    };
};

PDFTextNode.prototype.generate = function (pdf) {
    var flattenedNodes = flattenNodes(this.children);
    var pdfChildren = flattenedNodes.map(function (node) {
        var chunk = node.generate(pdf);
        return chunk;
    });
    return pdf.text(this._getOptions(), pdfChildren);
};

module.exports = PDFTextNode;
